/* eslint-disable */
import * as React from "react";
import { last, first } from "lodash";
import { ReportToolbar, ReportToolbarGroup, ReportToolbarSpacer, ReportToolbarNumber } from "../../components/ReportToolbar";
import { ReportGrid } from "../../components/ReportGrid";
import { ReportLayout } from "../../components/ReportLayout";
import { ReportHeader } from "../../components/ReportHeader";
import { ReportContainer } from "../../components/ReportContainer";
import { ReportRenderer } from "../../shared";
import { IndexEndHierarchyControl } from "./controls/IndexEndHierarchyControl";
import { IndexStartHierarchyControl } from "./controls/IndexStartHierarchyControl";
import { useExportQuery } from "./export/useExportQuery";
import { useFavourite } from "./favourite/useFavourite";
import { useSubscription } from "./subscription/useSubscription";
import { useSlideTitle } from "./hooks/useSlideTitle";
import { useSlideSubtitle } from "./hooks/useSlideSubtitle";
import { useDescription } from "./hooks/useDescription";
import { SLIDE_NUMBER } from "./constants";

export default function Slide23(props: { exportMode?: boolean }) {
  const { exportMode } = props;

  const title = useSlideTitle();
  const subtitle = useSlideSubtitle();
  const description = useDescription();

  useExportQuery(title, subtitle);
  useFavourite();
  useSubscription();

  return (
    <ReportContainer>
      <ReportHeader title={title} subtitle={subtitle} description={description} exportMode={exportMode} />
      <ReportToolbar exportMode={exportMode}>
        <ReportToolbarGroup>
          <IndexStartHierarchyControl />
          <IndexEndHierarchyControl />
        </ReportToolbarGroup>
        <ReportToolbarSpacer />
        <ReportToolbarNumber number={SLIDE_NUMBER} />
      </ReportToolbar>
      <ReportLayout>
        <ReportGrid>
          <ReportRenderer componentId="chart" />
        </ReportGrid>
      </ReportLayout>
    </ReportContainer>
  );
}
